import type {
	ModelRateDto,
	ModelRatesDto,
	ModelRateUpdate,
	UsageDailyDto,
	UsageOverviewDto,
} from "@/types/ai-assistant-usage";
import { request } from "./ai-assistant.api";

/** Fetcher meter pemakaian AI & tarif model (admin). */

export function fetchUsage(signal?: AbortSignal): Promise<UsageOverviewDto> {
	return request<UsageOverviewDto>("/usage", { signal }, "Memuat pemakaian AI");
}

export function fetchUsageDaily(
	days: number,
	signal?: AbortSignal,
): Promise<UsageDailyDto> {
	return request<UsageDailyDto>(
		`/usage/daily?days=${days}`,
		{ signal },
		"Memuat grafik pemakaian AI",
	);
}

export function fetchModelRates(signal?: AbortSignal): Promise<ModelRatesDto> {
	return request<ModelRatesDto>(
		"/model-rates",
		{ signal },
		"Memuat tarif model",
	);
}

export function saveModelRate(
	model: string,
	body: ModelRateUpdate,
): Promise<ModelRateDto> {
	return request<ModelRateDto>(
		`/model-rates/${encodeURIComponent(model)}`,
		{ method: "PUT", body: JSON.stringify(body) },
		"Menyimpan tarif model",
	);
}
